import axios from 'axios'
import router from '@/router/index.js'

import { useAuthStore } from '@/stores/auth'
import { useLoadingStore } from "@/stores/loadingStore.js"
import { toast } from "vue3-toastify"

import { has } from 'lodash'

const http = axios.create( {
  baseURL: import.meta.env.VITE_API_BASE_URL,
} )

http.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

http.interceptors.request.use(
  ( config ) => {
    useLoadingStore().incrementLoading()
    const authStore = useAuthStore()
    if ( authStore.token && !has( config.headers, 'Authorization' ) ) {
      config.headers['Authorization'] = `Bearer ${ authStore.token }`
    }
    return config
  },
  ( error ) => {
    return Promise.reject( error )
  }
)

http.interceptors.response.use(
  ( response ) => {
    useLoadingStore().decrementLoading()
    return response
  },
  ( error ) => {
    useLoadingStore().decrementLoading()
    const authStore = useAuthStore()
    if ( error.response && error.response.status === 401 && router.currentRoute.value.name !== 'login' ) {
      authStore.clearToken(); // Clear the token from store
      router.replace( { name: 'login', query: { redirect: router.currentRoute.value.fullPath } } );
    }
    else if ( error.response.status === 500 ) {
      toast.error( "An unknown error has occurred. If this continues, please contact support." )
    }
    return Promise.reject( error )
  }
)

export default http
